var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 145,
    viewBox: "0 0 144 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tabler-icon-user-circle"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 145,
    rx: 72,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.0078 113.879C38.4929 108.902 41.5316 104.54 45.6733 101.439C49.815 98.3388 54.8389 96.6651 59.9998 96.6667H83.9998C89.1674 96.6649 94.1975 98.3426 98.3421 101.45C102.487 104.558 105.525 108.93 107.004 113.916M18 72.5C18 79.6406 19.3968 86.7113 22.1105 93.3084C24.8243 99.9055 28.8019 105.9 33.8162 110.949C38.8306 115.998 44.7835 120.003 51.3351 122.736C57.8867 125.469 64.9086 126.875 72 126.875C79.0914 126.875 86.1133 125.469 92.6649 122.736C99.2165 120.003 105.169 115.998 110.184 110.949C115.198 105.9 119.176 99.9055 121.889 93.3084C124.603 86.7113 126 79.6406 126 72.5C126 65.3594 124.603 58.2887 121.889 51.6916C119.176 45.0945 115.198 39.1003 110.184 34.0511C105.169 29.0019 99.2165 24.9967 92.6649 22.2641C86.1133 19.5315 79.0914 18.125 72 18.125C64.9086 18.125 57.8867 19.5315 51.3351 22.2641C44.7835 24.9967 38.8306 29.0019 33.8162 34.0511C28.8019 39.1003 24.8243 45.0945 22.1105 51.6916C19.3968 58.2887 18 65.3594 18 72.5ZM54 60.4167C54 65.2237 55.8964 69.8339 59.2721 73.233C62.6477 76.6321 67.2261 78.5417 72 78.5417C76.7739 78.5417 81.3523 76.6321 84.7279 73.233C88.1036 69.8339 90 65.2237 90 60.4167C90 55.6096 88.1036 50.9995 84.7279 47.6004C81.3523 44.2013 76.7739 42.2917 72 42.2917C67.2261 42.2917 62.6477 44.2013 59.2721 47.6004C55.8964 50.9995 54 55.6096 54 60.4167Z",
    stroke: "#4B4B4B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUser);
export default __webpack_public_path__ + "static/media/noUser.e5e3132ddc70ae53de9810733b512ff8.svg";
export { ForwardRef as ReactComponent };